import { daysInFuture, endOfDay, endOfMonth, endOfMonthsAgo, endOfWeek, endOfWeeksAgo, endOfYear, endofDaysAgo, hoursAgo, hoursInFuture, minutesAgo, minutesInFuture, startOfDay, startOfDaysAgo, startOfMonth, startOfMonthsAgo, startOfWeek, startOfWeeksAgo, startOfYear, toDate, } from 'helpers/dates';
export const STOP_TYPES = [
    'loaded_pickup',
    'loaded_delivery',
    'empty_pickup',
    'empty_delivery',
    'offsite_loaded_pickup',
    'offsite_loaded_delivery',
    'offsite_empty_pickup',
    'offsite_empty_delivery',
];
export function toISODate(date) {
    if (!date) {
        return null;
    }
    return toDate(date).toISOString();
}
export const MONTHS_BACK = 4;
export const TIME_SELECTIONS = [
    {
        name: 'Last One Year',
        localizationSlug: 'LAST_ONE_YEAR',
        start: () => startOfDaysAgo(new Date(), 365),
        end: () => endOfDay(new Date()),
    },
    {
        name: 'Last 90 Days',
        localizationSlug: 'LAST_NINETY_DAYS',
        start: () => startOfDaysAgo(new Date(), 90),
        end: () => endOfDay(new Date()),
    },
    {
        name: 'Last 60 Days',
        localizationSlug: 'LAST_SIXTY_DAYS',
        start: () => startOfDaysAgo(new Date(), 60),
        end: () => endOfDay(new Date()),
    },
    {
        name: 'Last 30 Days',
        localizationSlug: 'LAST_THIRTY_DAYS',
        start: () => startOfDaysAgo(new Date(), 30),
        end: () => endOfDay(new Date()),
    },
    {
        name: 'Last 15 Days',
        localizationSlug: 'LAST_15_DAYS',
        start: () => startOfDaysAgo(new Date(), 15),
        end: () => endOfDay(new Date()),
    },
    {
        name: 'Last Month',
        localizationSlug: 'LAST_MONTH',
        start: () => startOfMonthsAgo(new Date(), 1),
        end: () => endOfMonthsAgo(new Date(), 1),
    },
    {
        name: 'Last Week',
        localizationSlug: 'LAST_WEEK',
        start: () => startOfWeeksAgo(new Date(), 1),
        end: () => endOfWeeksAgo(new Date(), 1),
    },
    {
        name: 'Yesterday',
        localizationSlug: 'YESTERDAY',
        start: () => startOfDaysAgo(new Date(), 1),
        end: () => endofDaysAgo(new Date(), 1),
    },
    {
        name: 'Tomorrow',
        localizationSlug: 'TOMORROW',
        start: () => startOfDaysAgo(new Date(), -1),
        end: () => endofDaysAgo(new Date(), -1),
    },
    {
        name: 'Last 4 Hours',
        localizationSlug: 'LAST_FOUR_HOURS',
        start: () => hoursAgo(new Date(), 4),
        end: () => new Date(),
    },
    {
        name: 'Last 2 Hours',
        localizationSlug: 'LAST_TWO_HOURS',
        start: () => hoursAgo(new Date(), 4),
        end: () => new Date(),
    },
    {
        name: 'Last 30 Minutes',
        localizationSlug: 'LAST_THIRTY_MIN',
        start: () => minutesAgo(new Date(), 4),
        end: () => new Date(),
    },
    {
        name: 'Today',
        localizationSlug: 'TODAY',
        start: () => startOfDay(new Date()),
        end: () => endOfDay(new Date()),
    },
    {
        name: 'Today & the Past',
        localizationSlug: 'TODAY_AND_THE_PAST',
        start: () => startOfDaysAgo(new Date(), 365),
        end: () => endOfDay(new Date()),
    },
    {
        name: 'Today & the Future',
        localizationSlug: 'TODAY_FUTURE',
        start: () => startOfDay(new Date()),
        end: () => endOfDay(daysInFuture(new Date(), 5)),
    },
    {
        name: 'Next 30 Minutes',
        localizationSlug: 'NEXT_THIRTY_MINS',
        start: () => new Date(),
        end: () => minutesInFuture(new Date(), 30),
    },
    {
        name: 'Next 2 Hours',
        localizationSlug: 'NEXT_TWO_HOURS',
        start: () => new Date(),
        end: () => hoursInFuture(new Date(), 2),
    },
    {
        name: 'Next 4 Hours',
        localizationSlug: 'NEXT_FOUR_HOURS',
        start: () => new Date(),
        end: () => hoursInFuture(new Date(), 4),
    },
    {
        name: 'This Week',
        localizationSlug: 'THIS_WEEK',
        start: () => startOfWeek(new Date()),
        end: () => endOfWeek(new Date(), 0),
    },
    {
        name: 'This Month',
        localizationSlug: 'THIS_MONTH',
        start: () => startOfMonth(new Date()),
        end: () => endOfMonth(new Date()),
    },
    {
        name: 'This Year',
        localizationSlug: 'THIS_YEAR',
        start: () => startOfYear(new Date()),
        end: () => endOfYear(new Date()),
    },
];
export const NOT_FULL_DAY_FILTERS = [
    'LAST_FOUR_HOURS',
    'LAST_TWO_HOURS',
    'LAST_THIRTY_MIN',
    'NEXT_THIRTY_MINS',
    'NEXT_TWO_HOURS',
    'NEXT_FOUR_HOURS',
];
/** @constant DEFAULT_DRAYAGE_COLS_OPS is an array of the field names spanning the domain of columns requested from OPS. team when viewing drayage records
 *  @type {Array}
 *  @default
 */
export const DEFAULT_DRAYAGE_COLS_OPS = [
    'shipment_id',
    'shipmentStatus',
    'billing_status_state_billing_status',
    'billing_status_state_pause_automated_billing_evaluation_reason_code',
    'billing_status_state_pause_automated_billing_evaluation_reason_codes',
    'billing_status_state_has_required_docs',
    'billing_status_state_missing_carrier_docs',
    'billing_status_state_has_missing_carrier_docs',
    'billing_status_state_missing_docs',
    'billing_status_state_has_required_reference_numbers',
    'billing_status_state_missing_reference_numbers',
    'billing_status_state_has_required_accessorials',
    'billing_status_state_missing_and_pending_required_accessorial_types',
    'billing_status_state_has_required_billable_stops',
    'billing_status_state_pending_billable_stops',
    'startsWith:latest_completed',
    'startsWith:empty_pickup__0',
    'startsWith:loaded_pickup__0',
    'startsWith:loaded_delivery__0',
    'startsWith:empty_delivery__0',
    'startsWith:offsite_loaded_delivery__0',
    'startsWith:offsite_loaded_pickup__0',
    'startsWith:empty_offsite_pickup__0',
    'startsWith:empty_offsite_delivery__0',
    'order_id',
    'orderStatus',
    'pod_status',
    'reference_numbers',
    'shipper_name',
    'carrier_name',
    'shipperCost',
    'carrierCost',
    'vendorCost',
    'delivery_order_status',
    'address',
    'on_hold_reason',
    'total_weight',
    'vessel_or_rail',
    'eta',
    'arrival_date',
    'lfd',
    'yard_lfd',
    'pickup_start',
    'pickup_end',
    'deliver_start',
    'deliver_end',
    'admin_notes',
    'is_pod_valid',
    'created_at',
    'arrived_date',
    'completed_date',
    'booking_number',
    'partnerShipmentId',
    'master_bol',
    'billing_status_state_has_pending_required_accessorials',
    'billing_status_state_has_missing_required_accessorials',
    'billing_status_state_has_pending_shipper_accessorials_or_unbilled_receivables_charge',
    'unbilled_charges',
    'billing_status_billable_event',
    'billing_status_invoice_grouping',
    'billing_status_pending_accessorial_evaluation',
    'billing_status_state_billing_status_modified_at',
    'billing_status_state_missing_required_accessorial_types',
    'billing_status_state_pending_required_accessorial_types'
];
export const STANDARD_REFERENCE_NUMBERS = [
    'quote_id',
    'delivery_order',
    'gate_dropoff',
    'gate_pickup',
    'house_bill_number',
    'isa',
    'master_bol',
    'mg_load_id',
    'mo_number',
    'pu_number',
    'seal_number',
    'tracking_id',
    'truck_order',
    'VRID',
    'work_order_number',
    'last_move',
    'final_destination',
    'cargo_weight',
    't_state',
    'position',
    'freight_kind',
    'over_weight',
    'reqs_power',
    'unit_impediments',
    'booking_number',
    'partnerShipmentId',
    'po_number',
    'Billing',
    'Shipment',
    'Mode',
    'CS NUMBER',
    'equipment_id',
    'chassis_number',
    'trailer_number',
    'category',
    'peel',
    'lcl',
    'leg_num',
    'bobtail',
];
export const DISABLE_BLANK_FILTER_WHITELIST = ['shipment_id', 'order_id'];
export const VIEWS = {
    FAVORITES: {
        name: 'favorites',
        slug: 'FAVORITES',
        href: '/unifiedview/favorites',
    },
    ALL_REPORTS: {
        name: 'all-reports',
        slug: 'ALL_REPORTS',
        href: '/unifiedview/reports',
    },
    MY_REPORTS: {
        name: 'my-reports',
        slug: 'MY_REPORTS',
        href: '/unifiedview/my-reports',
    },
    EXPLORE: {
        name: 'explore',
        slug: 'EXPLORE',
        href: '/unifiedview/explore',
    },
    COLUMN_CONFIG: {
        name: 'column-config',
        slug: 'COLUMN_CONFIGURATION',
        href: '/unifiedview/uv-column-config',
    },
    GROUPS: {
        name: 'groups',
    },
};
export const SIDEBAR_STATUSES = {
    EXPANDED: 'expanded',
    COLLAPSED: 'collapsed',
};
export const MISSING_ACCESSORIAL = ['fuel_surcharge', ''];
export const SHIPMENT_PRE_ARRIVAL_STATUS = {
    NA: 'N/A',
    PRE_NOTICE: 'pre_notice',
    FINAL: 'final',
    CONVERTED_FINAL: 'converted_final',
};
export const SHIPMENT_PRE_ARRIVAL_STATUS_BADGE_COLOR = {
    [SHIPMENT_PRE_ARRIVAL_STATUS.NA]: 'green',
    [SHIPMENT_PRE_ARRIVAL_STATUS.PRE_NOTICE]: 'blue',
    [SHIPMENT_PRE_ARRIVAL_STATUS.FINAL]: 'red',
};
export const SHIPMENT_PRE_ARRIVAL_STATUS_FILTER_LIST = [
    SHIPMENT_PRE_ARRIVAL_STATUS.NA,
    SHIPMENT_PRE_ARRIVAL_STATUS.PRE_NOTICE,
    SHIPMENT_PRE_ARRIVAL_STATUS.FINAL,
    SHIPMENT_PRE_ARRIVAL_STATUS.CONVERTED_FINAL,
].sort();
